import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface StickySaveFooterProps {
  completedFields: number;
  totalRequiredFields: number;
  onSave: () => void;
  saving: boolean;
}

export const StickySaveFooter = ({ completedFields, totalRequiredFields, onSave, saving }: StickySaveFooterProps) => {
  const isReady = completedFields >= totalRequiredFields;
  const remaining = totalRequiredFields - completedFields;

  return (
    <div className="fixed bottom-16 left-0 right-0 p-4 bg-background/90 backdrop-blur-md border-t z-40 md:bottom-0 md:pl-64">
      <div className="max-w-md mx-auto">
        <Button 
          size="lg" 
          className="w-full h-14 rounded-xl text-lg font-medium shadow-primary/20 shadow-lg transition-transform active:scale-[0.98]"
          onClick={onSave}
          disabled={!isReady || saving}
        >
          {saving && <Loader2 className="h-5 w-5 animate-spin mr-2" />}
          {!isReady 
            ? `Completa ${remaining} paso${remaining !== 1 ? 's' : ''} más` 
            : "Guardar check-in"}
        </Button>
      </div>
    </div>
  );
};
